
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.175 6l3.583-3.575a.837.837 0 00-1.183-1.183L6 4.825 2.425 1.242a.837.837 0 10-1.183 1.183L4.825 6 1.242 9.575a.833.833 0 000 1.183.833.833 0 001.183 0L6 7.175l3.575 3.583a.833.833 0 001.183 0 .832.832 0 000-1.183L7.175 6z","fill":"#FF0B0B"}})])
          )
        }
      }
    